import { slugify } from 'new/utils/slugify';
import { get } from 'lodash';

export function filterBy(search: string, ...fields: string[]) {
  return function (data: any) {
    for (const field of fields) {
      const value = get(data, field);
      if (
        !search ||
        (value && slugify(`${value}`.toLowerCase()).includes(slugify(search.toLowerCase())))
      ) {
        return true;
      }
    }
    return false;
  };
}
